import {
  CREATE_TRANSFER_REQUEST,
  CREATE_TRANSFER_SUCCESS,
  CREATE_TRANSFER_ERROR,
} from "./types.js";
import { BASEURL } from "../../constant/config.js";

const axios = require("axios");


export const createAutoTransfer = (token, transferData) => (dispatch) => {
  dispatch({ type: CREATE_TRANSFER_REQUEST });
  return axios({
    method: "POST",
    url: `${BASEURL}create/AutoItemTransfer`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: transferData,
  })
    .then((response) => {
      return dispatch({ type: CREATE_TRANSFER_SUCCESS, payload: response.data });
    })
    .catch((error) => {
      return dispatch({
        type: CREATE_TRANSFER_ERROR,
        payload: error.response,
      });
    });
};

